<template>
  <div style="background: #f3f3f3">
    <div class="tabBox flex">
      <div
        class="flex1 tabButton"
        :class="activeButton == 3 ? 'tabButtonActive' : ''"
        @click="getUntreated"
      >
        未处理消息
      </div>
      <div
        class="flex1 tabButton"
        :class="activeButton == 2 ? 'tabButtonActive' : ''"
        @click="getUnReadNotice"
      >
        未读消息<span class="tag" v-if="value">{{ value }}</span>
      </div>
      <div
        class="flex1 tabButton"
        :class="activeButton == 1 ? 'tabButtonActive' : ''"
        @click="getAllNotice"
      >
        全部消息
      </div>
    </div>
    <Scroller
      :style="{ height: scrollerHeight }"
      ref="scroll"
      :loadData="loadData"
      rowKey="id"
    >
      <template v-slot="{ item, i }">
        <div class="noticeBox" @click="goDetail(item)">
          <div
            class="noticeTitle"
            :class="item.status == 1 ? 'unRead' : 'isRead'"
          >
            {{ item.title }}
          </div>
          <div class="noticeTime">{{ item.createTime }}</div>
          <div
            class="noticeContent"
            :class="item.status == 1 ? 'unRead' : 'isRead'"
          >
            {{ item.content }}<span>(查看详情)</span>
          </div>
        </div>
      </template>
    </Scroller>
  </div>
</template>

<script>
import { getType } from "../../utils/auth";
import { noticePage, getUnreadNum, noticeRead } from "../../api/noticeCenter";
import Scroller from "@/components/Scroller";
import { jump, adminJump } from "./routerList.js";
export default {
  name: "noticeCenter",
  components: { Scroller },
  data() {
    return {
      activeButton: 3,
      noticeList: [],
      page: {
        current: 1,
        size: 10,
        classification: "OIL",
        status: "",
        isProcess: 1
      },
      value: "",
      loadData: params => {
        return noticePage({ ...params, ...this.page });
      }
    };
  },
  computed: {
    scrollerHeight: function() {
      return document.body.clientHeight - 89 - 46 + "px";
    }
  },
  created() {
    this.getUnreadNum();
  },
  methods: {
    goDetail(e) {
      console.log(e);

      if (e.status == 1) {
        noticeRead(e.id)
          .then(() => {
            this.getUnreadNum();
            if (getType() === "admin") {
              adminJump(this.$router, e.route, e.param);
            } else {
              jump(this.$router, e.route, e.param);
            }
          })
          .catch(err => {
            this.$showError(err);
          });
      } else {
        if (getType() === "admin") {
          console.log(1);
          adminJump(this.$router, e.route, e.param);
        } else {
          console.log(2);
          jump(this.$router, e.route, e.param);
        }
      }
    },
    getUnreadNum() {
      getUnreadNum()
        .then(res => {
          this.value = res;
        })
        .catch(err => {
          this.$showError(err);
        });
    },
    getUntreated() {
      if (this.activeButton != 3) {
        this.page.current = 1;
        this.page.status = "";
        this.activeButton = 3;
        this.page.isProcess = 1;
        this.$refs["scroll"].refresh();
      }
    },
    getAllNotice() {
      if (this.activeButton != 1) {
        this.page.current = 1;
        this.page.status = "";
        this.page.isProcess = "";
        this.activeButton = 1;
        this.$refs["scroll"].refresh();
      }
    },
    getUnReadNotice() {
      if (this.activeButton != 2) {
        this.page.current = 1;
        this.page.status = 1;
        this.page.isProcess = "";
        this.activeButton = 2;
        this.$refs["scroll"].refresh();
      }
    }
  }
};
</script>

<style scoped>
.tag {
  background-color: #f56c6c;
  display: inline-block;
  font-size: 12px;
  text-align: center;
  border-radius: 20px;
  width: 36px;
  height: 36px;
  line-height: 36px;
  color: #fff;
  margin-left: 10px;
}
.flex {
  display: flex;
}
.flex1 {
  flex: 1;
}
.tabBox {
  background: #f5f7fa;
  border-bottom: 1px solid #ebeef5;
}
.tabButton {
  color: #909399;
  font-size: 14px;
  text-align: center;
  height: 88px;
  line-height: 88px;
  margin-left: -1px;
  border-left: 1px solid #ebeef5;
}
.tabButtonActive {
  color: #409eff;
  background: #fff;
}
.noticeBox {
  margin: 20px;
  border: 1px solid #ebeef5;
  background: #fff;
  padding: 20px;
  border-radius: 6px;
}
.noticeTitle {
  font-size: 14px;
  line-height: 60px;
  color: #555;
  border-bottom: 1px solid #ebeef5;
}
.noticeTime {
  font-size: 12px;
  line-height: 40px;
  color: #555;
}
.noticeContent {
  color: #409eff;
  font-size: 14px;
  line-height: 48px;
}
.unRead {
  /*color: #000;*/
}
.isRead {
  color: #888a91;
}
</style>
